import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ClassificationFeedback } from './classification-feedback';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  constructor(private http: HttpClient) {}

  findAll(params: HttpParams): Observable<any> {
    const url = `${environment.url.api}/a/feedbacks`;
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  findOne(id: string): Observable<any> {
    const url = `${environment.url.api}/a/feedbacks/${id}`;
    return this.http
      .get<any>(url)
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  findProductNameCount(params: HttpParams): Observable<any> {
    const url = `${environment.url.api}/a/feedbacks/product-name/counts`;
    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  applyChanges(feedback: ClassificationFeedback) {
    const url = `${environment.url.api}/a/feedbacks`;
    return this.http
      .post<any>(url, feedback)
      .pipe(timeout(environment.config.apiWaitingTime));
  }

  editState(id: string, feedback: ClassificationFeedback) {
    const url = `${environment.url.api}/a/feedbacks/${id}`;
    return this.http
      .put<any>(url, feedback)
      .pipe(timeout(environment.config.apiWaitingTime));
  }
}
